import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dropdown from '@helsenorge/designsystem-react/components/Dropdown';
import Globe from '@helsenorge/designsystem-react/components/Icons/Globe';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import LanguageNames, { BokmaalLanguageName } from '../language-picker-wrapper/resources';
import { Projects, useResources } from '../resources';
import { useAppSelector } from '../store/hooks';
import styles from './styles.module.scss';
const getLanguageName = (language, languages) => {
    if (language == LanguageLocales.NORWEGIAN && languages.includes(LanguageLocales.NORWEGIAN_NYNORSK)) {
        return BokmaalLanguageName;
    }
    return LanguageNames[language];
};
export const LanguagePicker = ({ languages, onLanguageChange, className, testId }) => {
    const selectedLanguage = useAppSelector(state => selectCurrentLanguage(state.language));
    const resources = useResources(Projects.FRAMEWORK);
    const handleLanguageChange = async (newLanguage) => {
        onLanguageChange(newLanguage);
    };
    const languageChangedMessage = resources?.languageChanged ?? `Language changed to ${LanguageNames[selectedLanguage]}`;
    return (_jsxs("div", { className: className, "data-testid": testId, children: [_jsx("span", { className: styles['language-picker__message'], "aria-live": "polite", children: languageChangedMessage }), _jsx(Dropdown, { svgIcon: Globe, triggerText: resources?.language_picker_trigger_text ?? 'Språk/Language', variant: "borderless", noCloseButton: true, dropdownMinWidth: 300, children: languages.map(language => (_jsx(Dropdown.SingleSelectItem, { text: getLanguageName(language, languages), asChild: true, defaultSelected: language === selectedLanguage, children: _jsx("button", { onClick: () => handleLanguageChange(language), "data-testid": testId ? `${testId}-${language}` : undefined }) }, language))) })] }));
};
export default LanguagePicker;
